export default __webpack_public_path__ + "static/video-nav-1b0b84ceb5da2b4aa9775d39ff00b92f.svg";